export default {
  screens: [
    {
      type: 'intro',
      title: 'Chaumet<br> et le Japon',
      content:
        'La fascination de Chaumet pour l’archipel nippon remonte aux origines de la Maison.<br/><br/>Curiosité réciproque, puisque de nombreux clients japonais ont élu Chaumet.',
      idYt: 'vGycDLMlTz4',
      videoCover: 'world/japan/video.jpg',
      desktop: {
        cover: 'world/japan/cover-1.jpg'
      },
      mobile: {
        cover: 'world/japan/mobile-cover-1.jpg',
        contentStyle: {
          width: '100%'
        },
        coverStyle: {
          width: '100%',
          bottom: '0%',
          left: '0',
          right: 'inherit',
          position: 'relative'
        }
      }
    },
    {
      type: 'triangle',
      desktop: {
        topImg: 'world/japan/triangleTop.jpg',
        btmImg: 'world/japan/triangleBtm.jpg',
        cover: 'world/japan/cover-2.jpg'
      },
      mobile: {
        topImg: 'world/japan/mobileTriangleTop.jpg',
        btmImg: 'world/japan/triangleBtm.jpg',
        cover: 'world/japan/cover-2.jpg'
      },
      content:
        'L’émerveillement de Nitot devant les laques de la reine Marie-Antoinette, puis la passion de Joséphine pour  les essences japonaises, sont fondateurs. La Maison n’a depuis cessé de s’inspirer du Japon pour ses créations.<br/><br/> Une collection de Haute Joaillerie spécialement créée présente en majesté ces liens avec le Japon.'
    },
    {
      type: 'column',
      leftImg: 'world/japan/columnLeft.jpg',
      middleImg: 'world/japan/columnMiddle.jpg',
      rightImg: 'world/japan/columnRight.jpg',
      title: 'Chant du Printemps',
      content:
        'Couleurs franches de l’encre et de la laque, nature renaissante associée à la pureté géométrique, la parure diffuse l’essence même de la culture nippone.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/fr/worlds/japan.js